'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { createElement, useEffect, type ComponentProps } from 'react'

/**
 * The mobile menu's custom elements, fetched only on the viewports that have a mobile menu.
 *
 * `@tailwindplus/elements/react` imports the library from an effect that runs on mount, so every
 * visitor downloads it — measured at 84 KB (23.5 KB gzip) on every page, with Lighthouse finding
 * 90% of it unused. What it powers here is one `<dialog>` behind a button that is `lg:hidden`. A
 * desktop visitor cannot open that menu at all and was paying for it on every page of the site.
 *
 * So the import waits on the same condition the button does. Below `lg` it loads immediately, as
 * before — the library polyfills `command`/`commandfor` for browsers older than spring 2025, and
 * delaying that would mean a first tap that does nothing. Above `lg` it never loads, and starts if
 * the window is narrowed, which is the only way a desktop visitor can reach the button.
 *
 * Deliberately not used for `<el-tab-*>`. A tab panel with no definition yet is a panel with
 * nothing hiding it, so the pricing page's three plan tables would render stacked until the import
 * landed. That page keeps the vendor wrappers and is the only one that pays for them.
 */
const MOBILE_MENU = '(width < 64rem)' // Tailwind's `lg`, matching the button's `lg:hidden`

let loaded = false

function loadWhenMobile(): (() => void) | undefined {
  if (loaded || typeof window === 'undefined' || !window.matchMedia) return
  const query = window.matchMedia(MOBILE_MENU)
  const load = () => {
    if (loaded || !query.matches) return
    loaded = true
    void import('@tailwindplus/elements')
  }
  load()
  if (loaded) return
  query.addEventListener('change', load)
  return () => query.removeEventListener('change', load)
}

function useElementsDefinition() {
  useEffect(() => loadWhenMobile(), [])
}

export function ElDialog(props: ComponentProps<'div'>) {
  useElementsDefinition()
  return createElement('el-dialog', props)
}

export function ElDialogPanel(props: ComponentProps<'div'>) {
  useElementsDefinition()
  return createElement('el-dialog-panel', props)
}
